import { render, staticRenderFns } from "./sentinelaRolagemInfinita.vue?vue&type=template&id=063ca3df&scoped=true"
import script from "./sentinelaRolagemInfinita.vue?vue&type=script&lang=js"
export * from "./sentinelaRolagemInfinita.vue?vue&type=script&lang=js"
import style0 from "./sentinelaRolagemInfinita.vue?vue&type=style&index=0&id=063ca3df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063ca3df",
  null
  
)

export default component.exports